import pickBy from 'lodash/pickBy'
import stringify from 'json-stable-stringify'
import mapKeys from 'lodash/mapKeys'
import camelCase from 'lodash/camelCase'
import fastDeepEqual from 'fast-deep-equal'

/**
 * Returns a new object with all undefined values removed.
 */
export function omitUndefined(obj: any) {
  return pickBy(obj, (value) => value !== undefined)
}

/**
 * Returns a new object with shallow-camelized keys.
 *
 * @param {*} obj
 */
export function camelizeKeys(obj: Record<string, unknown>) {
  return mapKeys(obj, (_, key) => camelCase(key))
}

/**
 * Gets a cacheable string for an object.
 * @param obj
 */
export function getCacheKeyForObject(obj: unknown): string {
  return stringify(obj)
}

/**
 * Checks that a value is not nil.
 * @param value
 */
export function isNotNil<T>(
  value: T | null | undefined,
): value is Exclude<T, null | undefined> {
  return value !== undefined && value !== null
}

/**
 * Whether the values are deeply equal.
 *
 * @param left
 * @param right
 */
export function areDeepEqual<T>(left: T, right: T): boolean {
  return fastDeepEqual(left, right)
}
